import React, { useState } from 'react';
import omit from 'lodash/omit';
import startCase from 'lodash/startCase';
import shortid from 'shortid';
import {
  ErrorMessage,
} from 'formik';

import FormField from './FormField.jsx';
import FormRadioField from './FormRadioField.jsx';

const FormGroup = (props) => {
  const {
    label,
    name,
    radio,
    required = false,
    helpText,
    prepend,
    append,
  } = props;
  const [id] = useState(() => `a${shortid.generate()}`);
  const p = {
    id,
    ...omit(props, ['label', 'required', 'helpText']),
  };
  const f = radio ? <FormRadioField {...p} /> : <FormField {...p} />;

  return (
    <div className="form-group">
      {label !== null && (
        <label htmlFor={id}>
          {label || startCase(name)}
          {required ? ' *' : ''}
        </label>
      )}
      {prepend || append ? (
        <div className="input-group">
          {prepend && (
            <div className="input-group-prepend">
              {prepend}
            </div>
          )}
          {f}
          {append && (
            <div className="input-group-append">
              {append}
            </div>
          )}
          <ErrorMessage name={name}>
            {(msg) => (
              <div className="invalid-feedback">{msg}</div>
            )}
          </ErrorMessage>
        </div>
      ) : f}
      {helpText && (
        <small className="form-text text-muted">
          {helpText}
        </small>
      )}
      <ErrorMessage name={name}>
        {(msg) => (
          <div className="invalid-feedback">{msg}</div>
        )}
      </ErrorMessage>
    </div>
  );
};

export default FormGroup;
